import { List, type ListProps } from "@mui/material";
import { type Ref, forwardRef } from "react";
import { AutocompleteAppellationsPaperSelectedOptions } from "./selectedOptions";

export const AutocompleteAppellationsList = forwardRef(
  ({ children, ...props }: ListProps, ref: Ref<HTMLUListElement>) => {
    return (
      <List {...props} ref={ref}>
        {children}
        <AutocompleteAppellationsPaperSelectedOptions />
      </List>
    );
  }
);
